import { render, staticRenderFns } from "./CorrespondenceForm.vue?vue&type=template&id=fc702a62&"
import script from "./CorrespondenceForm.vue?vue&type=script&lang=js&"
export * from "./CorrespondenceForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports